// ============================================================================
// MODULAR DESIGN PRINCIPLES (MANDATORY)
// ============================================================================
// This file strictly follows:
// 1. Single Responsibility Principle - Display active model indicator
// 2. Separation of Concerns - Presentation only
// 3. Modular Architecture - Reusable chip
//
// Refer to: docs/architecture/modular-design-standards.md
// ============================================================================

/**
 * Active Ollama model badge (resolved default for chat).
 */

import React from 'react';
import { Chip } from '@mui/material';
import { CheckCircle as CheckIcon } from '@mui/icons-material';

const PRIMARY = '#13213c';

const ActiveModelBadge = ({ modelName }) => (
  <Chip
    icon={<CheckIcon />}
    label={`Active: ${modelName || '—'}`}
    sx={{
      fontWeight: 'bold',
      px: 1,
      bgcolor: PRIMARY,
      color: '#fff',
      '& .MuiChip-icon': { color: '#fff' },
    }}
  />
);

export default ActiveModelBadge;
